import CashRunwayVisual from "./visuals/CashRunwayVisual";
import CashConversionVisual from "./visuals/CashConversionVisual";
import ClassificationMixVisual from "./visuals/ClassificationMixVisual";
import ConfidenceSpectrumVisual from "./visuals/ConfidenceSpectrumVisual";
import DrillGeometryVisual from "./visuals/DrillGeometryVisual";
import InSituValueVisual from "./visuals/InSituValueVisual";
import LassondeCurveVisual from "./visuals/LassondeCurveVisual";
import LifecycleResourceValuationVisual from "./visuals/LifecycleResourceValuationVisual";
import MarginWaterfallVisual from "./visuals/MarginWaterfallVisual";
import MiningLifecycleVisual from "./visuals/MiningLifecycleVisual";
import ReserveConfidenceVisual from "./visuals/ReserveConfidenceVisual";
import ResourceReserveVisual from "./visuals/ResourceReserveVisual";
import ResourceOunceVisual from "./visuals/ResourceOunceVisual";
import ShareDilutionVisual from "./visuals/ShareDilutionVisual";
import ValuationBridgeVisual from "./visuals/ValuationBridgeVisual";

const VISUALS = {
  cash_conversion: CashConversionVisual,
  cash_runway: CashRunwayVisual,
  classification_mix: ClassificationMixVisual,
  confidence_spectrum: ConfidenceSpectrumVisual,
  drill_geometry: DrillGeometryVisual,
  in_situ_value: InSituValueVisual,
  lassonde_curve: LassondeCurveVisual,
  lifecycle_resource_valuation: LifecycleResourceValuationVisual,
  margin_waterfall: MarginWaterfallVisual,
  mining_lifecycle: MiningLifecycleVisual,
  reserve_confidence: ReserveConfidenceVisual,
  resources_reserves: ResourceReserveVisual,
  resource_ounce: ResourceOunceVisual,
  share_dilution: ShareDilutionVisual,
  valuation_bridge: ValuationBridgeVisual,
};

export default function LearnVisual({ visual }) {
  if (!visual?.type) return null;

  const Component = VISUALS[visual.type];
  if (!Component) return null;

  return <Component {...visual} />;
}
